import { createSelector } from 'reselect';
import { METADATA_KEY } from './constants';
import searchSelector from '../searchSelector';

export const getSearchMetadata = createSelector(
    searchSelector,
    search => search[METADATA_KEY]
);
